"use strict";

module.exports = {
  'name': 'config',
  'category': 'Core',
  'syntax': ['config()', 'config(options)'],
  'description': 'Get configuration or change configuration.',
  'examples': ['config()', '1/3 + 1/4', 'config({number: "Fraction"})', '1/3 + 1/4'],
  'seealso': []
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/expression/embeddedDocs/core/config.js
// module id = 812
// module chunks = 0